<template>
  <section
    class="text-co-gray-50"
    :style="{ backgroundColor: bg }"
  >
    <div class="co-container-md mx-auto flex flex-col md:flex-row">
      <div
        class="w-full p-7 md:w-1/6 lg:w-1/4"
        :style="{ backgroundColor: titleBg }"
      >
        <div
          class="co-display-5 mx-auto mb-3 flex items-center justify-center rounded-full border-2 border-white text-center"
          style="width: 60px; height: 60px"
        >
          <FontAwesomeIcon
            :icon="faUserPlus"
            class="fa-fw size-8"
          />
        </div>
        <h2 class="mx-auto w-1/4 md:w-full">
          <img
            class="h-auto max-w-full"
            src="~/assets/images/Te/TeCommon/Tomowari/tomowari-logo.png"
            alt="トモ割！"
            width="408"
            height="220"
            loading="lazy"
          >
        </h2>
      </div>
      <div class="w-full px-4 pb-7 pt-4 md:w-5/6 lg:w-3/4">
        <h3 class="co-display-8 mb-3 border-b pb-3 text-center font-bold">
          <span class="mb-2 block lg:inline">同僚や友人と一緒に受講すると</span>
          <span class="block lg:inline">受講料が<b class="co-display-4 font-bold">10,000</b>円割引！</span>
        </h3>
        <p class="co-display-12 mb-4">
          <span>一緒に受講される同僚や友人の名前を「お申し込みフォーム」の備考欄に入力してください。受講料が1万円割引になります。</span>
          <span>ぜひお誘い合わせのうえ、このお得な割引をご利用ください。</span>
        </p>
        <div class="mb-4 flex flex-col items-center bg-white text-center text-co-gray-700 lg:flex-row">
          <div class="w-full bg-co-gray-300 px-6 py-4 font-bold lg:w-1/3">
            備考欄に入力するワード
          </div>
          <div class="w-full p-4 lg:w-2/3 lg:py-2">
            <span class="co-display-9 block pr-4 lg:inline">tomowari友人の名前</span>
            <span class="co-display-13 text-co-gray-500">例）tomowari煌木太郎</span>
          </div>
        </div>
        <p class="co-display-13 mb-4">
          ※他の割引との併用はできません。<br>
          ※申し込みした方と友人とが別の<span v-if="set">セット</span><span v-else>コース</span>になっても割引は適用されます。<br>
          ※割引はお一人様につき1回のみの適用となります。
        </p>
        <div class="text-center">
          <a
            class="co-btn-ghost-white rounded-full border"
            href="#apply"
            @click.prevent="scrollTo('apply')"
          >お申し込みフォームへ</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUserPlus } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faUserPlus,
    }
  },
  props: {
    set: {
      type: Boolean,
      default: false,
    },
    bg: {
      type: String,
      default: '#5cb85c',
      required: false,
    },
    titleBg: {
      type: String,
      default: '#449d44',
      required: false,
    },
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineComponent(options)
</script>
